import { handleGetCapexData } from '@modules/capex/application/get-capex-data'
import { handleUploadCapexFile } from '@modules/capex/application/upload-capex-file'
import { handleDownloadCapexFile } from '@modules/capex/application/download-capex-file'
import {
  CAPEX_API_ERRORS,
  CAPEX_ERROR_KEYS,
} from '@modules/capex/domain/capex.errors'

async function fetchCapexData({ commit }) {
  function onCapexData(data) {
    commit('SET_CAPEX_DATA', data)
  }

  function onNetworkError() {
    commit('SET_ERROR_REQUEST_CAPEX', true)
    throw new Error('api-error')
  }

  await handleGetCapexData().execute({
    onCapexData,
    onNetworkError,
  })
}

const uploadCapexFile = async ({ commit }, file) => {
  commit('SET_ERROR_UPLOAD_FILE', { isError: false })

  function onSuccess() {
    commit('SET_UPLOADED_FILE_SUCCESS', true)
  }

  function onNetworkError(error) {
    const errorCode =
      error?.response?.data?.error === CAPEX_API_ERRORS.PAST_DATE
        ? CAPEX_ERROR_KEYS.PAST_DATE
        : null

    commit('SET_ERROR_UPLOAD_FILE', { isError: true, message: errorCode })
    throw new Error('api-error')
  }
  await handleUploadCapexFile().execute(file, {
    onSuccess,
    onNetworkError,
  })
}

const downloadCapexFile = async ({ commit }, configId) => {
  commit('SET_ERROR_DOWNLOAD_FILE', false)

  function onSuccess(file) {
    commit('SET_DOWNLOAD_CAPEX_FILE', file)
  }

  function onNetworkError() {
    commit('SET_ERROR_DOWNLOAD_FILE', true)
    throw new Error('api-error')
  }
  await handleDownloadCapexFile().execute(configId, {
    onSuccess,
    onNetworkError,
  })
}

export default {
  fetchCapexData,
  uploadCapexFile,
  downloadCapexFile,
}
